import React, { useEffect, useReducer, useContext } from 'react'

import { LEVELS, BLOCK_SCORE } from '../settings/levels'
import { MOVEMENT, getNewGameState, getGameStateFromLevel } from '../settings/core'
import { registerListener } from '../settings/utils'

import Level from './level'
import Lives from './lives'
import Block from './block'
import Paddle from './paddle'
import Ball from './ball'
import Score from './scroe';

import { GameContext } from '../Game';


const MOVEMENT_KEYS = {
    LEFT: [65, 37],
    RIGHT: [68, 39]
}

export const STOP_KEY = 400
export const RESUME_KEY = 500


const UPDATE_EVERY = 1000 / 60


const getInitialLevel = () => 0
// For score

const getInitialScore = () => 0


const getProjectors = (containerSize, gameSize) => {
    const widthRatio = containerSize.width / gameSize.width
    const heightRatio = containerSize.height / gameSize.height
    const unitOnScreen = Math.min(widthRatio, heightRatio)

    return {
        projectDistance: distance => distance * unitOnScreen,
        projectVector: vector => vector.scaleBy(unitOnScreen)
    }
}

const getInitialState = containerSize => {
    const level = getInitialLevel();
    const score = getInitialScore();
    const highestScore = 0;
    const game = getGameStateFromLevel(LEVELS[level])
    const { projectDistance, projectVector } = getProjectors(containerSize, game.size)
    return {
        level,
        score,
        highestScore,
        actions: [],
        game,
        containerSize,
        projectDistance,
        projectVector,
        time: Date.now(),
        stopTime: undefined,
        movement: undefined
    }
}

export const ACTION = {
    CONTAINER_SIZE_CHANGE: 'CONTAINER_SIZE_CHANGE',
    KEY_DOWN: 'KEY_DOWN',
    KEY_UP: 'KEY_UP',
    TICK: 'TICK',
    TOUCH_START: 'TOUCH_START',
    TOUCH_END: 'TOUCH_END',
}

export const HANDLER = {
    [ACTION.CONTAINER_SIZE_CHANGE]: (state, containerSize) => ({
        ...state,
        containerSize,
        ...getProjectors(containerSize, state.game.size)
    }),
    [ACTION.KEY_DOWN]: (state, key) => {
        if (MOVEMENT_KEYS.LEFT.includes(key)) {
            return { ...state, movement: MOVEMENT.LEFT }
        } else if (MOVEMENT_KEYS.RIGHT.includes(key)) {
            return { ...state, movement: MOVEMENT.RIGHT }
        }
        return state
    },
    [ACTION.KEY_UP]: (state, key) => {
        console.log("KEY UP EVENT OCCURS " + key);
        console.log("CHECK FOR KEY EVENT " + state);
        const newState = { ...state, movement: undefined }
        // FIXME: So this occurs whether key is pressed or not
        // but the if statements do not work for the dispatchEvent()

        // When pauseGame() happens it seems to stop at line 93
        // when you press the appropriate key after this happens, it only logs stop or resume
        // it DOES NOT log key up event again, it seems as if it is waiting for a key
            if (key === STOP_KEY) {
            console.log("STOPPPPPPP");
            return { ...newState, stopTime: Date.now() }


            // if (state.stopTime) {
            //     return { ...newState, stopTime: undefined, time: state.time + Date.now() - state.stopTime }
            // } else {
            //     return { ...newState, stopTime: Date.now() }
            // }
        }

        if (key === RESUME_KEY){
            console.log("RESUMEEEEEE");
            return { ...newState, stopTime: undefined, time: state.time + Date.now() - state.stopTime }
        }
        
        return newState
    },
    [ACTION.TOUCH_END]: (state) => {

        const newState = { ...state, movement: undefined }


        return newState;
    },
    [ACTION.TOUCH_START]: (state, event) => {

        let movement = undefined;
        let actions = state.actions;
        const time = (new Date()).toString();

        if (event.touches[0].clientX < event.viewWidth / 2.0) {
            const action = "left";
            actions.push({ action, time })
            movement = MOVEMENT.LEFT;
        } else {
            const action = "right";
            actions.push({ action, time })
            movement = MOVEMENT.RIGHT;
        }

        return { ...state, actions, movement };
    },
    [ACTION.TICK]: state => {
        if (state.stopTime) return state;

        const time = Date.now()
        const oldBlocksNumber = state.game.blocks.length;

        const newGame = getNewGameState(state.game, state.movement, time - state.time)
        const newState = { ...state, time }

        const newBlockNumber = newGame.blocks.length;

        const score = state.score + (oldBlocksNumber - newBlockNumber) * BLOCK_SCORE;

        const highestScore = Math.max(state.highestScore, score);



        if (newGame.lives < 1) {
            // update the highestScore
            //localStorage.setItem("highestScore", highestScore);
            //localStorage.setItem("actions", JSON.stringify(state.actions));

            return { ...state, highestScore, level: getInitialLevel(), score: getInitialScore(), game: getGameStateFromLevel(LEVELS[getInitialLevel()]) }
        } else if (newGame.blocks.length < 1) {
            const level = state.level === LEVELS.length ? state.level : state.level + 1
 
            const game = getGameStateFromLevel(LEVELS[state.level])
            return {
                ...newState,
                level,
                score,
                highestScore,
                game,
                ...getProjectors(state.containerSize, game.size)
            }
        }
        return { ...newState, score, highestScore, game: newGame }
    }
}

const reducer = (state, { type, payload }) => {
    const handler = HANDLER[type]
    if (!handler) return state
    return handler(state, payload)
}



export default (containerSize) => {
    const gameContext = useContext(GameContext);

    const [state, dispatch] = useReducer(reducer, containerSize, getInitialState)
    const act = (type, payload) => dispatch({ type, payload })
    const {
        projectDistance,
        projectVector,
        level,
        score,
        highestScore,
        actions,
        game: {
            blocks,
            paddle,
            ball,
            size: {
                width,
                height
            },
            lives
        }
    } = state

    const viewWidth = projectDistance(width)
    const unit = projectDistance(ball.radius)

    useEffect(() => act(ACTION.CONTAINER_SIZE_CHANGE, containerSize), [containerSize])

    useEffect(() => {
        const onKeyDown = ({ which }) => act(ACTION.KEY_DOWN, which)
        const onKeyUp = ({ which }) => act(ACTION.KEY_UP, which)
        const tick = () => act(ACTION.TICK)
        const onTouchStart = ({ touches }) => act(ACTION.TOUCH_START, { touches, viewWidth })
        const onTouchEnd = ({ touches }) => act(ACTION.TOUCH_END, touches)

        const timerId = setInterval(tick, UPDATE_EVERY)
        const unregisterKeydown = registerListener('keydown', onKeyDown);
        const unregisterKeyup = registerListener('keyup', onKeyUp);
        const unregisterTouchStart = registerListener('touchstart', onTouchStart);
        const unregisterTouchEnd = registerListener('touchend', onTouchEnd);


        return () => {
            clearInterval(timerId);
            unregisterKeydown();
            unregisterKeyup();
            unregisterTouchEnd();
            unregisterTouchStart();

        }
    }, [viewWidth])

    useEffect(() => {

        gameContext.gameDispatch({ scores: highestScore, actions })

    }, [highestScore]);


    return (
        <svg width={viewWidth} 
            height={projectDistance(height)} 
            className='scene'>
            <Level unit={unit} level={level + 1} />
            <Score unit={unit} width={viewWidth} score={score} highestScore={highestScore} />
            <Lives
                lives={lives}
                containerWidth={viewWidth}
                unit={unit}
            />
            {blocks.map(({ density, position, width, height }) => (
                <Block
                    density={density}
                    key={`${position.x}-${position.y}`}
                    width={projectDistance(width)}
                    height={projectDistance(height)}
                    {...projectVector(position)}
                />)
            )}
            <Paddle width={projectDistance(paddle.width)} height={projectDistance(paddle.height)} {...projectVector(paddle.position)} />
            <Ball {...projectVector(ball.center)} radius={unit} />
        </svg>
    )
}